<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <!-- <list
      row-key="RecordId"
      ref="list"
      unit="警报数据"
      :page="page"
      :show-checkbox="multiple"
      :show-query="false"
      :query-params="params"
      :get-data-func="api.list"
      @check-change="checkChange"
      :reset-data-func="resetData"
      v-if="trendShow"
      urlHash="facility/equipment/warmdata"
      :temp-params="tempParams"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list> -->

    <el-form label-width="100px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="报警时间">
            {{ data.Warmtime }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="报警内容">
            {{ data.Warmmessage }}
          </el-form-item>
        </el-col>
      </el-row></el-form
    >
  </div>
</template> 
<script>
//import listMixin from '@/mixins/trend/list'
// import list from '@/components/common/trendsTable/list'

export default {
  mixins: [],
  components: {},
  props: {
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      api: require('@/api/equipment/warmdata').default,
      trendShow: true,
      params: {
        ProductName: '',
        MouldName: ''
      },
      tempParams: {
        //    ProgrammeType: 1
      },
      data: {},
      ids: []
    }
  },
  methods: {
    getInfo(id) {
      console.log(id, 'get')
      this.api.getLastInfo(id).then(res => {
        this.data = res.Data        
      })
    }
  }
}
</script>
